import { Box, Grid, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DataUnavailable from '../../../components/data/DataUnavailable';
import GetSiteRec from '../../../components/api/GetSiteRec';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSite } from '../../../components/siteselector/SiteContext';
import SkySparkGrid from '../../../components/api/SkySparkGrid';
import { tokens } from '../../../theme';
import { BenchmarkChart } from '../../../components/charts/ems';
import LoginCookieAuth from '../../../components/api/LoginCookieAuth';
import Cookies from 'js-cookie';
import YearPicker from '../../../components/yearpicker/YearPicker';
import GetParam from '../../../components/api/GetParam';
import { useYear } from '../../../components/yearpicker/YearContext';
import GetUser from '../../../components/api/GetUser';
import InfLoader from '../../../components/infLoad/'

export default function BenchmarkScene() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { siteId } = useParams()
  const [siteName, setSiteName] = useState("");
  const [, setSiteRec] = useState({});
  const navigate = useNavigate();
  const { selectedSite } = useSite();
  const { selectedYear } = useYear();
  const location = useLocation()
  const [pageAcces, SetPageAcces] = useState(false)

  //prepare chart boxes
  const [benchmarkElectricity, setBenchmarkElectricity] = useState([]);
  const [benchmarkGas, setBenchmarkGas] = useState([]);
  const [benchmarkHeat, setBenchmarkHeat] = useState([]);
  const [benchmarkWater, setBenchmarkWater] = useState([]);
  
  //prepare validity
  const [benchmarkElectricityValid, setBenchmarkElectricityValid] = useState(false);
  const [benchmarkGasValid, setBenchmarkGasValid] = useState(false);
  const [benchmarkHeatValid, setBenchmarkHeatValid] = useState(false);
  const [benchmarkWaterValid, setBenchmarkWaterValid] = useState(false);

  //loading charts
  const [loadingElec, setLoadingElec] = useState(true)
  const [loadingGas, setLoadingGas] = useState(true)
  const [loadingHeat, setLoadingHeat] = useState(true)
  const [loadingWater, setLoadingWater] = useState(true)

  useEffect(() => {
    GetUser().then((response) => {
      const pageWhitelist = response.data["rows"][0].infSiteModules
      if(pageWhitelist.includes('ems/benchmark')) {
        SetPageAcces(true)
      } else {
        navigate('/projects')
      }
    });
    LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async(authResponse) => {
      if(authResponse) {
          // Get yearrange from url parameters
          const yearRange = GetParam('dateRange', location)
        if(!loadingElec) {
          setLoadingElec(true)
          setLoadingGas(true)
          setLoadingHeat(true)
          setLoadingWater(true)
        }
        SkySparkGrid(`api_benchmarkElectricityUsage(@${siteId}, ${yearRange})`).then((response) => {
          if(response.status === 504){
            console.log('504 error encounterd')
            return;
          }
          if (response.data['rows'].length === 0  || response.data["meta"]["sampleCount"] === 0) {
            setBenchmarkElectricityValid(false);
            setLoadingElec(false)
          } else {
            setBenchmarkElectricityValid(true)
            const responseData = response.data
            setBenchmarkElectricity((<BenchmarkChart gridRows={responseData["rows"]} gridMeta={responseData["meta"]} gridCols={responseData["cols"]}/>))
            setLoadingElec(false)
          }
        })
    
        SkySparkGrid(`api_benchmarkGasUsage(@${siteId}, ${yearRange})`).then((response) => {
          if(response.status === 504){
            console.log('504 error encounterd')
            return;
          }
          if (response.data['rows'].length === 0  || response.data["meta"]["sampleCount"] === 0) {
            setBenchmarkGasValid(false);
            setLoadingGas(false)
          } else {
            setBenchmarkGasValid(true)
            const responseData = response.data
            setBenchmarkGas((<BenchmarkChart gridRows={responseData["rows"]} gridMeta={responseData["meta"]} gridCols={responseData["cols"]}/>))
            setLoadingGas(false)
          }
        })
    
        SkySparkGrid(`api_benchmarkHeatUsage(@${siteId}, ${yearRange})`).then((response) => {
          if(response.status === 504){
            console.log('504 error encounterd')
            return;
          }
          if (response.data['rows'].length === 0  || response.data["meta"]["sampleCount"] === 0) {
            setBenchmarkHeatValid(false);
            setLoadingHeat(false)
          } else {
            setBenchmarkHeatValid(true)
            const responseData = response.data
            setBenchmarkHeat((<BenchmarkChart gridRows={responseData["rows"]} gridMeta={responseData["meta"]} gridCols={responseData["cols"]}/>))
            setLoadingHeat(false)
          }
        })
    
        SkySparkGrid(`api_benchmarkWaterUsage(@${siteId}, ${yearRange})`).then((response) => {
          if(response.status === 504){
            console.log('504 error encounterd')
            return;
          }
          if (response.data['rows'].length === 0  || response.data["meta"]["sampleCount"] === 0) {
            setBenchmarkWaterValid(false);
            setLoadingWater(false)
          } else {
            setBenchmarkWaterValid(true)
            const responseData = response.data
            setBenchmarkWater((<BenchmarkChart gridRows={responseData["rows"]} gridMeta={responseData["meta"]} gridCols={responseData["cols"]}/>))
            setLoadingWater(false)
          }
        })
    
        if (siteId !== "undefined") {
          GetSiteRec(siteId).then((response) => {
            const responseVal = response.data["rows"][0]
            setSiteRec(responseVal)
            setSiteName(responseVal["navName"])
          })
        }
        //scroll after navigating
        document.getElementById('content').scrollTo(0, 0)
      }
  })
      // eslint-disable-next-line
  }, [navigate, siteId, siteName, selectedSite, selectedYear]);
  
  return (
    <>
    {
      pageAcces ? (
        <Box m="18px" maxWidth="100%">
        {/* TOP ROW - BUTTONS*/}
        <Box display="grid" sx={{ p: "0 0 18px 0", display:'flex' }}>
          <YearPicker/>
        </Box>
        
        {/* Grid - Charts */}
        <Grid container gap={2} direction={{ xs: "column", sm: "column", md: "column", lg: "column", xl: "row" }} wrap="nowrap" height='100%' sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
          <Grid item xl={6} lg={12} backgroundColor={colors.primary[400]}>
            <Box sx={{ height: '100%', padding: '20px', minWidth: '418px', maxHeight:'433px' }}>
              <Typography variant="h5" fontWeight="bold" color={colors.greenAccent[500]} textAlign='center'>Elektralevering</Typography>
              <Typography variant="h6" fontWeight="bold" color={colors.greenAccent[100]} textAlign='center'>Genormaliseerd naar oppervlakte</Typography>
              <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '350px', width: '99%'}}>
               {
                loadingElec ? (<InfLoader/>) : (benchmarkElectricityValid ? benchmarkElectricity : <DataUnavailable/>)
               }
              </Box>
            </Box>
          </Grid>
          <Grid item xl={6} lg={12} backgroundColor={colors.primary[400]}>
            <Box sx={{ height: '100%', padding: '20px', minWidth: '418px', maxHeight:'433px' }}>
              <Typography variant="h5" fontWeight="bold" color={colors.greenAccent[500]} textAlign='center'>Gaslevering</Typography>
              <Typography variant="h6" fontWeight="bold" color={colors.greenAccent[100]} textAlign='center'>Genormaliseerd naar oppervlakte</Typography>
              <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '350px', width: '99%' }}>
              {
                loadingGas ? (<InfLoader/>) : (benchmarkGasValid ? benchmarkGas : <DataUnavailable/>)
              }
              </Box>
            </Box>
          </Grid>
          <Grid item xl={4} lg={12}>
            <Box sx={{ height: '100%', padding: '20px', minWidth: '300px' }}>
              <Typography sx={{fontSize:'16px'}} fontWeight="bold" color={colors.greenAccent[500]}>Informatie over verbruiken</Typography>
              <br />
              <Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras eget pretium tellus, ac suscipit sem. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur vel efficitur urna, a gravida mi. Quisque mauris purus, auctor in mollis congue, ultrices nec tellus. Duis tempus congue nulla, at efficitur est condimentum et. Vestibulum tincidunt pretium tincidunt. Proin sagittis commodo consequat. Donec ac gravida neque. Etiam ullamcorper tristique rhoncus.</Typography>
              <br />
              <Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras eget pretium tellus, ac suscipit sem. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur vel efficitur urna, a gravida mi. Quisque mauris purus, auctor in mollis congue, ultrices nec tellus. Duis tempus congue nulla, at efficitur est condimentum et. Vestibulum tincidunt pretium tincidunt. Proin sagittis commodo consequat. Donec ac gravida neque. Etiam ullamcorper tristique rhoncus.</Typography>
            </Box>
          </Grid>
        </Grid>
        <br />
        <Grid container gap={2} direction={{ xs: "column", sm: "column", md: "column", lg: "column", xl: "row" }} wrap="nowrap" height='100%' sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
          <Grid item xl={6} lg={12} backgroundColor={colors.primary[400]}>
            <Box sx={{ height: '100%', padding: '20px', minWidth: '418px', maxHeight:'433px' }}>
              <Typography sx={{fontSize:'16px'}} fontWeight="bold" color={colors.greenAccent[500]} textAlign='center'>Warmtelevering</Typography>
              <Typography sx={{fontSize:'14px'}} fontWeight="bold" color={colors.greenAccent[100]} textAlign='center'>Genormaliseerd naar oppervlakte</Typography>
  
              <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '350px', width: '99%' }}>
              {
                loadingHeat ? (<InfLoader/>) : (benchmarkHeatValid ? benchmarkHeat : <DataUnavailable/>)
              }
              </Box>
            </Box>
          </Grid>
          <Grid item xl={6} lg={12} backgroundColor={colors.primary[400]}>
            <Box sx={{ height: '100%', padding: '20px', minWidth: '418px', maxHeight:'433px' }}>
              <Typography sx={{fontSize:'16px'}} fontWeight="bold" color={colors.greenAccent[500]} textAlign='center'>Waterlevering</Typography>
              <Typography sx={{fontSize:'14px'}} fontWeight="bold" color={colors.greenAccent[100]} textAlign='center'>Genormaliseerd naar oppervlakte</Typography>
              <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '350px', width: '99%' }}>
              {
                loadingWater ? (<InfLoader/>) : (benchmarkWaterValid ? benchmarkWater : <DataUnavailable/>)
              }
              </Box>
            </Box>
          </Grid>
          <Grid item xl={4} lg={12}>
            <Box sx={{ height: '100%', padding: '20px', minWidth: '300px' }}>
              <Typography sx={{fontSize:'16px'}} fontWeight="bold" color={colors.greenAccent[500]}>Primaire energie</Typography>
              <br />
              <Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras eget pretium tellus, ac suscipit sem. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur vel efficitur urna, a gravida mi. Quisque mauris purus, auctor in mollis congue, ultrices nec tellus. Duis tempus congue nulla, at efficitur est condimentum et. Vestibulum tincidunt pretium tincidunt. Proin sagittis commodo consequat. Donec ac gravida neque. Etiam ullamcorper tristique rhoncus.</Typography>
              <br />
              <Typography sx={{fontSize:'16px'}} fontWeight="bold" color={colors.greenAccent[500]}>Secundaire energie</Typography>
              <br />
              <Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras eget pretium tellus, ac suscipit sem. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur vel efficitur urna, a gravida mi. Quisque mauris purus, auctor in mollis congue, ultrices nec tellus. Duis tempus congue nulla, at efficitur est condimentum et. Vestibulum tincidunt pretium tincidunt. Proin sagittis commodo consequat. Donec ac gravida neque. Etiam ullamcorper tristique rhoncus.</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      ) : (
        null
      )
    }
    </>
  )
}
